/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateQuickbooksVerificationKeyInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createQuickbooksVerificationKeyMutationVariables = {|
  input: CreateQuickbooksVerificationKeyInput
|};
export type createQuickbooksVerificationKeyMutationResponse = {|
  +createQuickbooksVerificationKey: ?{|
    +key: ?string
  |}
|};
export type createQuickbooksVerificationKeyMutation = {|
  variables: createQuickbooksVerificationKeyMutationVariables,
  response: createQuickbooksVerificationKeyMutationResponse,
|};
*/


/*
mutation createQuickbooksVerificationKeyMutation(
  $input: CreateQuickbooksVerificationKeyInput!
) {
  createQuickbooksVerificationKey(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateQuickbooksVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateQuickbooksVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createQuickbooksVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createQuickbooksVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createQuickbooksVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createQuickbooksVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createQuickbooksVerificationKeyMutation(\n  $input: CreateQuickbooksVerificationKeyInput!\n) {\n  createQuickbooksVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '28ca01b35748cc020ac8b50cb99c4bed';

module.exports = node;
